var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.14144 5.76953L0.426952 1.31215C-0.00726546 0.791085 0.363259 -4.31825e-07 1.04153 -4.02177e-07L7.62546 -1.14384e-07C8.30373 -8.47357e-08 8.67426 0.791085 8.24004 1.31215L4.52555 5.76953C4.4256 5.88947 4.24139 5.88947 4.14144 5.76953Z",
    fill: "#7161BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPurple);
export default __webpack_public_path__ + "static/media/arrowPurple.a79e0f166b5862ad37ab9c40a0e8f6d5.svg";
export { ForwardRef as ReactComponent };